import * as React from 'react';

export class CrossSellCarouselModel {
    private readonly _title: string | React.JSX.Element;

    constructor(public readonly title: string | React.JSX.Element) {
        this._title = title;
    }

    public get carouselTitle(): string | React.JSX.Element {
        return this._title;
    }
}